import React from "react";
import { Pagination } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

const Paginate = ({ pages, page, isAdmin = false, keyword = "" }) => {
  if (pages <= 1) return null;

  const getRoute = (pg) =>
    isAdmin
      ? `/admin/products/${pg}`
      : keyword
      ? `/search/${keyword}/page/${pg}`
      : `/page/${pg}`;

  return (
    <Pagination style={{ display: "flex", justifyContent: "center" }}>
      {/* Previous Arrow */}
      {page > 1 ? (
        <LinkContainer to={getRoute(page - 1)}>
          <Pagination.Prev />
        </LinkContainer>
      ) : (
        <Pagination.Prev disabled />
      )}

      {/* Page Numbers */}
      {[...Array(pages).keys()].map((x) => (
        <LinkContainer key={x + 1} to={getRoute(x + 1)}>
          <Pagination.Item active={x + 1 === page}>{x + 1}</Pagination.Item>
        </LinkContainer>
      ))}

      {/* Next Arrow */}
      {page < pages ? (
        <LinkContainer to={getRoute(page + 1)}>
          <Pagination.Next />
        </LinkContainer>
      ) : (
        <Pagination.Next disabled />
      )}
    </Pagination>
  );
};

export default Paginate;
